import { XMarkIcon } from '@heroicons/react/20/solid';
import axios from 'axios';
import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";

const PaymentReceivableBill = ({ idCrypt, close }) => {
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [payment, setPayment] = useState(null);
    const [billDetails, setBillDetails] = useState([]);

    const fetchData = async () => {
        try {
            setLoading(true);

            const response = await axios.get(`public/api/payment-receivables/${idCrypt}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            });
            
            setBillDetails(response?.data?.payment_receivable?.bill_allocations || []);
            const data = response?.data?.payment_receivable;
            setPayment(data);
            setBillDetails(data?.bill_allocations || []);
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            }
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

      if (loading) {
    return (
      <div className="h-screen bg-white">
        <div className="flex justify-center items-center h-full">
          <img
            className="h-16 w-16"
            src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
            alt="loader"
          />
        </div>
      </div>
    );
  }

return (
  <div className="bg-white rounded-lg shadow-md overflow-hidden">

    {/* HEADER (your existing code) */}
    <div className="flex items-center justify-between p-4 border-b border-gray-200">
      <h3 className="text-lg sm:text-md font-semibold text-blue-800">
         Bill Allocations
      </h3>
      <XMarkIcon
        onClick={close}
        className="h-8 w-8 cursor-pointer bg-red-600 rounded-full text-white p-2"
      />
    </div>

    {/* PAYMENT SUMMARY */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-gray-50">
      <div className="bg-white p-4 rounded-lg border">
        <p className="text-xs text-gray-500">Receipt No</p>
        <p className="font-semibold text-gray-800">
          {payment?.receipt_no}
        </p>
      </div>

      <div className="bg-white p-4 rounded-lg border">
        <p className="text-xs text-gray-500">Party Name</p>
        <p className="font-semibold text-gray-800">
          {payment?.party_name}
        </p>
      </div>

      <div className="bg-blue-600 p-4 rounded-lg text-white">
        <p className="text-xs opacity-80">Total Amount</p>
        <p className="text-xl font-bold">
          ₹{payment?.total_amount}
        </p>
      </div>
    </div>

    {/* DETAILS SECTION */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
      <div>
        <p className="text-xs text-gray-500">Account Name</p>
        <p className="font-medium text-gray-800">
          {payment?.account_name}
        </p>
      </div>

      <div>
        <p className="text-xs text-gray-500">Type of Work</p>
        <p className="font-medium text-gray-800">
          {payment?.type_of_work}
        </p>
      </div>

      <div>
        <p className="text-xs text-gray-500">Sales Person</p>
        <p className="font-medium text-gray-800">
          {payment?.sales_person}
        </p>
      </div>

      <div>
        <p className="text-xs text-gray-500">Collection Person</p>
        <p className="font-medium text-gray-800">
          {payment?.collection_person}
        </p>
      </div>

      <div>
        <p className="text-xs text-gray-500">Project Manager</p>
        <p className="font-medium text-gray-800">
          {payment?.project_manager}
        </p>
      </div>
    </div>

    {/* BILL ALLOCATION LIST */}
    <div className="p-4 border-t">
      <h4 className="font-semibold text-gray-700 mb-3">
        Bill Allocations
      </h4>

      <div className="space-y-3">
        {billDetails?.map((bill, index) => (
          <div
            key={bill.id}
            className="flex items-center justify-between bg-gray-50 border rounded-lg p-3"
          >
            <div>
              <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                {bill.type}
              </span>
              <p className="font-medium text-gray-800 mt-1">
                {bill.bill_no}
              </p>
            </div>

            <p className="font-semibold text-green-600">
              ₹{bill.amount}
            </p>
          </div>
        ))}

        {billDetails?.length === 0 && (
          <p className="text-sm text-gray-400 text-center">
            No bill allocations available
          </p>
        )}
      </div>
    </div>
  </div>
);


}

export default PaymentReceivableBill